import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { SemanticUI } from '@iterable/deprecated_react_components';

export const StyledSemanticButtonGroup = styled(SemanticUI.Button.Group)`
  &&& {
    background: #fff;
  }
`;

export const StyledSemanticDropdown = styled(SemanticUI.Dropdown)`
  &&& {
    width: 100%;
  }
`;

export const StyledSemanticDropdownMenu = styled(SemanticUI.Dropdown.Menu)<{
  $isOptionsMenu?: boolean;
}>`
  &&& {
    ${({ $isOptionsMenu }) =>
      $isOptionsMenu
        ? `
      box-shadow: none !important;
      border: none !important;
    `
        : ''}
  }
`;

export const StyledSemanticDropdownDivider = styled(SemanticUI.Dropdown.Divider)`
  &&& {
    margin: 0 !important;
  }
`;

export const StyledSemanticInput = styled(SemanticUI.Input)`
  &&& {
    .input {
      margin: ${pxToRem(10)};
    }
  }
`;

export const StyledSemanticDropdownItem = styled(SemanticUI.Dropdown.Item)`
  &&&&&&& {
    display: flex;
    align-items: center;
    gap: ${pxToRem(10)};
    .cssSubText {
      font-size: ${pxToRem(12)};
    }
  }
`;

export const Trigger = styled.div`
  display: flex;
  flex-wrap: wrap;
  &:not([data-tags]) {
    pointer-events: none;
  }
  &[data-tags] {
    padding: ${pxToRem(5)};
    margin: -${pxToRem(12.5)} -${pxToRem(20)};
  }
`;

export const StyledSemanticCheckbox = styled(SemanticUI.Checkbox)`
  &&& {
    margin: 0;
    height: 0;
    pointer-events: none;
    > input {
      pointer-events: none;
    }
  }
`;
